import type CK from '~/types/contentking';

import {
	useAccountIsSubscriptionRenewalEnabledQuery,
} from './useAccountIsSubscriptionRenewalEnabled.gql';

import useAccountPropertiesQuery from '~/hooks/useAccountPropertiesQuery';



function useAccountIsSubscriptionRenewalEnabled(accountId: CK.AccountId | null) {
	const { data } = useAccountPropertiesQuery(
		useAccountIsSubscriptionRenewalEnabledQuery,
		accountId,
	);

	return data?.account?.isSubscriptionRenewalEnabled ?? null;
}



export default useAccountIsSubscriptionRenewalEnabled;
